export default __webpack_public_path__ + "2751595000f2fe140a49d05f040ccb5abf950be5ff97dfd3cc6f22d5c0ca516a.svg";